
import { OLMSApiService } from '@/shared/apis'
import { ThunkApiContext } from '@/shared/store'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'

import { refreshData } from './refreshData'

export type PublishUnassignedOrdersPayload = {
  id: EntityId // The Scenario Id
  dateOfOperation: string
  onSuccess?: () => void
}

export const publishUnassignedOrders = createAsyncThunk<number | null, PublishUnassignedOrdersPayload, ThunkApiContext>(
  'scenario/publishUnassignedOrders',
  async ({ onSuccess, ...payload }, { dispatch }) => {
    await OLMSApiService.post<null>('planning/publishUnassignedOrders', payload)
    await dispatch(refreshData({}))

    const orderInboxCount = await OLMSApiService.get<number>('/planning/OrderInboxCount')

    if (onSuccess) {
      onSuccess()
    }

    return orderInboxCount
  },
)
